<template>
  <div class="combox-purchase-display">
    <ComboboxPurchaseItemInfo
      :item="item.purchaseItem"
      :unit-price="item.unitPrice"
      :project="item.project"
      :has-custom-unit-price="item.hasCustomUnitPrice"
    />
    <div v-if="!item.date" class="text-error font-medium">Geen inkoopdatum geselecteerd!</div>
    <div v-else-if="!item.date.isSame(instruction.date)">
      <span class="text-xs">{{ item.date.format("DD-MM-YYYY") }}</span>
    </div>

    <!-- Surcharge description -->
    <div v-if="item.surchargeDescription" class="text-xs">
      {{ item.surchargeDescription }}
    </div>

    <!-- Information about surcharge that applies to this purchase (consolidated view) -->
    <ConsolidatedSurchargesDisplay :original-transaction="item" :transaction-id="item.id!" />

    <!-- Comment -->
    <div v-if="item.comment" class="text-xs">
      <FontAwesomeIcon :icon="['fas', 'comment']" size="sm" />
      {{ item.comment }}
    </div>

    <div v-if="!item.project" class="text-error font-medium">Geen project geselecteerd!</div>
    <div v-else-if="item.project.id !== instruction.project?.id" class="text-warning">
      {{ item.project?.getDisplayText() }}
    </div>

    <!-- Linked incoming invoices -->
    <div v-if="item.incomingInvoicePurchases.length > 0" class="italic">
      <FontAwesomeIcon :icon="['fas', 'link']" size="sm" />
      {{ normalizeDecimal(item.getMatchedQuantity(), { minDecimalPlaces: 0 }) }} &mdash;

      {{ item.incomingInvoicePurchases.length === 1 ? "Inkoopfactuur" : "Inkoopfacturen:" }}
      <span v-for="(iip, index) in item.incomingInvoicePurchases" :key="iip.id">
        <span v-if="iip.incomingInvoiceReference">{{ iip.incomingInvoiceReference }}</span>
        <span v-else>(geen kenmerk)</span>
        <span v-if="index < item.incomingInvoicePurchases.length - 1">, </span>
      </span>
    </div>

    <!-- Error display -->
    <div v-if="error">
      <ComboboxProcessingItemErrorDisplay :model-value="error" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Purchase } from "@/models/purchase.model"
import ComboboxPurchaseItemInfo from "@/components/administration/combobox-display-templates/basic/ComboboxPurchaseItemInfo.vue"
import { inject, type Ref } from "vue"
import type { Instruction } from "@/models/instruction.model"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import type { BaseException } from "@/exceptions/base-exception.exception.ts"
import ComboboxProcessingItemErrorDisplay from "@/components/administration/combobox-display-templates/nested/ComboboxProcessingItemErrorDisplay.vue"
import { normalizeDecimal } from "@/helper/number-helper.ts"
import ConsolidatedSurchargesDisplay from "@/components/administration/combobox-display-templates/nested/ConsolidatedSurchargesDisplay.vue"

defineProps<{
  item: Purchase
  error?: BaseException
}>()

const instruction: Ref<Instruction> = inject("instruction")!
</script>

<style scoped></style>
